import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EditSessionComponent } from '../edit-session/edit-session.component';
import { InfoCardComponent } from 'src/app/components/shared/info-card/info-card.component';

interface SessionData {
  session: any;
  event: any;
}

@Component({
  selector: 'app-day-sessions',
  templateUrl: './day-sessions.component.html',
  styleUrls: ['./day-sessions.component.scss']
})
export class DaySessionsComponent implements OnInit {

  selectedDate: Date;
  formattedDate: string;
  sessions: SessionData[] = [];
  currentIdEvent: number | null = null;
  existingSessions: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<DaySessionsComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    if (this.data) {
      this.selectedDate = this.data.date;
      // Mostramos primero las sesiones más recientes en el modal
      this.sessions = (this.data.sessions || []).slice().reverse();
      this.currentIdEvent = this.data.currentIdEvent || null;
      this.existingSessions = this.data.existingSessions || [];
      this.formattedDate = this.formatDate(this.selectedDate);
    }
  }

  formatDate(date: Date): string {
    const monthNames = [
      'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
      'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
    ];

    const day = date.getDate();
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  }

  getSessionTime(session: any): string {
    // Verificar si existe start_date o datetime
    const dateTimeString = session.start_date || session.datetime;

    if (!dateTimeString) return '';

    // Si tiene el formato "YYYY-MM-DD HH:MM:SS", extraer solo la hora
    if (typeof dateTimeString === 'string' && dateTimeString.includes(' ')) {
      const time = dateTimeString.split(' ')[1];
      if (time) {
        return time.substring(0, 5); // HH:MM
      }
    }

    // Formato "...T...Z": el backend etiqueta como UTC una hora que en
    // realidad es local, así que se recupera con los getters UTC (igual
    // que en edit-session.component.ts) en vez de convertir a hora local.
    const date = new Date(dateTimeString);
    const hours = date.getUTCHours().toString().padStart(2, '0');
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');

    return `${hours}:${minutes}`;
  }

  canEditSession(sessionData: SessionData): boolean {
    const sessionIdEvent = sessionData.session.id_event || sessionData.event.id;

    // Puede editar si:
    // 1. Es una sesión temporal (marcada con _isTemporary)
    // 2. O el idEvent de la sesión coincide con el idEvent actual
    if (sessionData.session._isTemporary) {
      return true;
    }

    if (this.currentIdEvent && sessionIdEvent === this.currentIdEvent) {
      return true;
    }

    return false;
  }

  editSession(sessionData: SessionData): void {
    // Solo permitir edición si cumple las condiciones
    if (!this.canEditSession(sessionData)) {
      return;
    }

    const idEvent = sessionData.session.id_event || sessionData.event.id;

    const editDialogRef = this.dialog.open(EditSessionComponent, {
      panelClass: ['info-dialog', 'not-padding'],
      disableClose: true,
      width: '750px',
      data: {
        eventName: sessionData.event.title,
        sessionId: sessionData.session.id,
        idEvent: idEvent,
        sessionData: sessionData.session,
        temporarySessionIndex: sessionData.session._temporaryIndex,
        existingSessions: this.existingSessions
      }
    });

    editDialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        // Si hubo algún cambio exitoso, cerrar este dialog y notificar al padre
        this.dialogRef.close(result);
      } else if (result && !result.success && result.error) {
        this.openDialogInfo(result.error);
      }
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  openDialogInfo(text: string) {
      this.dialog.open(InfoCardComponent, {
        panelClass: 'info-dialog',
        data: {
          icon: true,
          text: text,
          btnCancel: false
        }
      });
    }
}
